const SECONDS = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
const PLAIN = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 })

/** Длительность словами: «420 мс» до секунды, дальше «5,6 с». Пусто — «—». */
export function durationText(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '—'
  if (ms < 1000) return `${Math.round(ms)} мс`
  return `${SECONDS.format(ms / 1000)} с`
}

/** Доля участка: «18 %». Нулевое целое не показывается как «0 %» у ненулевого участка — «<1 %». */
export function shareText(ms: number, total: number): string {
  if (total <= 0) return '—'
  const share = (ms / total) * 100
  return share > 0 && share < 1 ? '<1 %' : `${Math.round(share)} %`
}

/** Смещение от начала: «+0 мс», «+1,2 с». */
export function offsetText(ms: number): string {
  return `+${durationText(Math.max(0, ms))}`
}

export function numberText(value: number): string {
  return PLAIN.format(value)
}
